module.exports = __webpack_public_path__ + "static/media/Welcome_Bonus_web.5da51725.png";